module.exports = __webpack_public_path__ + "static/media/header-background.c2088fd0.mp4";